import { regExpEscape } from "./RegExpHelper";

export function isOneEmoji(stringToCheck: string) {
    const emojiRegex = new RegExp(
        "^(\\p{Emoji_Presentation}|\\p{Extended_Pictographic}|\\p{Emoji_Modifier_Base})\\p{Emoji_Modifier}?$",
        "gu",
    );

    return emojiRegex.test(stringToCheck);
}

/**
 * Splits a string into an array of words,
 * filtering out words which length is more than minWordLength characters.
 *
 * searchValue might be undefined to ease work with optional component parameters.
 *
 * @param {string} searchValue
 * @param {string} delimiter
 * @param {number} minWordLength
 * @returns {string[] | undefined}
 */
export const splitSearchValue = (
    searchValue?: string,
    delimiter: string = " ",
    minWordLength: number = 2,
): string[] | undefined => {
    return searchValue
        ?.trim()
        ?.split(delimiter)
        ?.filter((searchQuery) => searchQuery.length > minWordLength);
};

/**
 * Highlight fragments provided in textToHighlight in content text
 * by wrapping each of these fragments into a span element.
 *
 * @param {string} content
 * @param {string[]} textToHighlight
 * @returns {string}
 */
export const highlightText = (
    content: string,
    textToHighlight: string[],
): string => {
    if (textToHighlight.length === 0) {
        return content;
    }

    const concatenatedSearchTerm = textToHighlight
        .map(regExpEscape)
        .sort((l, r) => r.length - l.length)
        .join("|");

    return content.replace(
        new RegExp(`\\b(${concatenatedSearchTerm})\\b`, "ig"),
        (match) =>
            `<span style="color:var(--community-color-primary-text);font-weight:700">${match}</span>`,
    );
};

export const getUrlHost = (url: string) => {
    return new URL(url).hostname;
};
